import WidgetReservationListResourceModel from '../../generated/types/model/resource/WidgetReservationListResourceModel';

export default class WidgetReservationListResourceViewModel extends WidgetReservationListResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
